/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/


import React from "react";
import { Content, LoaderContainer, LoaderBar } from "./styles";
import { Col, Row } from "components/Grid";
import { NotesAccordion } from "components";
import EnquiryCard, { EnquiryCardContainer } from 'components/EnquiryCard'

const idProduct55 = ['NÚMERO', 'RAMO', 'CPF/ CNPJ DO SEGURADO / RECLAMANTE', 'CPF/ CNPJ DO TOMADOR', 'CORRETOR', 'MODALIDADE', 'VIGÊNCIA', 'IMPORTÂNCIA SEGURADA/LIMITE'];

const idProduct57 = ['NÚMERO', 'RAMO', 'CPF/ CNPJ DO SEGURADO / RECLAMANTE', 'MODALIDADE', 'CNPJ DO TOMADOR', 'CORRETOR', 'VIGÊNCIA', 'IMPORTÂNCIA SEGURADA/LIMITE'];

export default function Loading({ idProduct }) {
  const fieldsToRender = idProduct === 55 ? idProduct55 : idProduct57;
  return (
    idProduct && (
      <Content>
        <Row style={{ flexDirection: 'column' }}>
          <EnquiryCardContainer>
          {fieldsToRender.map((field, index) => {
              return (
                <Col key={index} xs={12} md={4} style={{ paddingLeft: 0, marginBottom: 10, paddingRight: '15px' }}>
                  <EnquiryCard
                    person={{}}
                    idQuestion={1}
                    field={field}
                    value={
                      <LoaderContainer>
                        <LoaderBar />
                      </LoaderContainer>
                    }
                  />
                </Col>)
            })}
          </EnquiryCardContainer>
        </Row>
      </Content>
    )
  );
}
